import { websiteRequest } from 'src/editor/shared/utils/request'
import { WebsitePageInterface } from 'src/editor/store/website-pages/website-pages-types'
import { websitePageMock } from 'src/editor/mocks/website-page.mock'

/**
 * @description discommend when the api is ready
 */

// export const getWebsitePageById = (id: number) =>
//   websiteRequest<WebsitePageInterface>(`/pages/${id}`, 'GET')

export const getWebsitePageById = (id: number) => websitePageMock(id)
